import { ModalBody, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export interface ISiteManageSchedulesModalProps {
  unitId: string
}

export const SiteManageSchedulesModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ISiteManageSchedulesModalProps
}) => (
  <ModalContainer alwaysMobile innerClasses='!max-w-[700px]'>
    <ModalHeaderContainer>
      <div className='flex items-center justify-between gap-[10px]'>
        <ModalHeader subtitle='Schedules' subtitleClasses='capitalize' />
        <button
          type='button'
          aria-label='Close filter'
          className='bg-secondary-content/5 text-secondary-content text-[1.2em] w-[35px] h-[35px] rounded-full flex items-center justify-center'
          onClick={() => {
            onDismiss(null, ModalDismiss.Confirm)
          }}
        >
          <commonIcons.close />
        </button>
      </div>
    </ModalHeaderContainer>
    <ModalBody classes='!pt-[140px] !pb-[100px] sm:!pb-[70px] w-full'>
      <div />
    </ModalBody>
  </ModalContainer>
)
